var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ProgressActivate',{attrs:{"action-names":_vm.actionNames},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var isLoading = ref.isLoading;
return [_c('v-btn',_vm._g({staticClass:"turnOrange",attrs:{"loading":isLoading,"disabled":_vm.disabled,"color":_vm.color},on:{"click":_vm.clickAction}},_vm.on),[_vm._t("default")],2)]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }